document.addEventListener('DOMContentLoaded', () => {
  initProductCardSliders();
});

document.addEventListener('shopify:section:load', () => {
    initProductCardSliders();
});

// Re-initialize after pagination/facet updates
document.addEventListener('facet:update', () => {
    setTimeout(initProductCardSliders, 100);
});

// Listen for custom pagination events
document.addEventListener('pagination:change', () => {
    setTimeout(initProductCardSliders, 100);
});

// Use MutationObserver to catch dynamically added product cards
const productListObserver = new MutationObserver((mutations) => {
    let shouldInit = false;
    mutations.forEach((mutation) => {
        if (mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1 && (
                    node.classList?.contains('product-card') ||
                    node.querySelector?.('.product-card__slider-container')
                )) {
                    shouldInit = true;
                }
            });
        }
    });
    if (shouldInit) {
        setTimeout(initProductCardSliders, 50);
    }
});

// Observe the main content area for changes
document.addEventListener('DOMContentLoaded', () => {
    const productList = document.querySelector('product-list, .collection, main');
    if (productList) {
        productListObserver.observe(productList, { childList: true, subtree: true });
    }
});

function initProductCardSliders() {
    const containers = document.querySelectorAll('.product-card__slider-container:not([data-slider-initialized])');
    containers.forEach(container => {
        new ProductCardSlider(container);
    });
}

class ProductCardSlider {
    constructor(container) {
        this.container = container;
        this.slider = container.querySelector('.product-card__slider');
        this.prevBtn = container.querySelector('.product-card__arrow--prev');
        this.nextBtn = container.querySelector('.product-card__arrow--next');
        // Legacy bar removal if present
        this.indicatorBar = container.querySelector('.product-card__scroll-indicator-bar'); 
        this.slides = this.slider.querySelectorAll('.product-card__slider-item');
        
        if (this.slides.length <= 1) return; 

        this.container.setAttribute('data-slider-initialized', 'true');
        
        this.setupEventListeners();
        this.updateState();

        // Observe for visibility/size changes (Fix for A/B test toggling)
        if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(entries => {
                for (let entry of entries) {
                    if (entry.contentRect.width > 0) {
                        this.updateState();
                    }
                }
            });
            this.resizeObserver.observe(this.slider);
        }
    }

    setupEventListeners() {
        if (this.prevBtn) {
            this.prevBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.scroll('prev');
            });
        }

        if (this.nextBtn) {
            this.nextBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.scroll('next');
            });
        }

        // Throttle scroll updates slightly for performance if needed, 
        // but for smooth UI RAF is good.
        this.slider.addEventListener('scroll', () => {
             // Use requestAnimationFrame for performance
             if (!this.ticking) {
                 window.requestAnimationFrame(() => {
                     this.updateState();
                     this.ticking = false;
                 });
                 this.ticking = true;
             }
        }, { passive: true });
    }

    scroll(direction) {
        // Ensure we have correct width logic even if it was 0 previously
        const slideWidth = this.slider.clientWidth;
        if (slideWidth === 0) return;

        const currentScroll = this.slider.scrollLeft;
        const targetScroll = direction === 'next' 
            ? currentScroll + slideWidth 
            : currentScroll - slideWidth;

        this.slider.scrollTo({
            left: targetScroll,
            behavior: 'smooth'
        });
    }

    updateState() {
        const scrollLeft = this.slider.scrollLeft;
        const width = this.slider.clientWidth;
        // If hidden (width 0), we can't calculate correctly.
        if (width === 0) return;

        const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
        // Allow a small buffer for float calculations
        const buffer = 5;

        // Update Arrows
        if (this.prevBtn && this.nextBtn) {
            if (scrollLeft <= buffer) { 
                this.prevBtn.setAttribute('disabled', 'true');
            } else {
                this.prevBtn.removeAttribute('disabled');
            }

            if (scrollLeft >= maxScroll - buffer) {
                this.nextBtn.setAttribute('disabled', 'true');
            } else {
                this.nextBtn.removeAttribute('disabled');
            }
        }

        // Update Dots
        const dots = this.container.querySelectorAll('.product-card__scroll-indicator-dot');
        if (dots.length > 0) {
            const index = Math.round(scrollLeft / width);
            const totalDots = dots.length;
            const maxVisible = 5;

            let start = 0;
            let end = totalDots;

            if (totalDots > maxVisible) {
                // Calculate window
                // We want 'index' to be roughly in the middle (position 2 of 0-4)
                // Middle index of 5 is 2.
                // targetStart = index - 2
                
                if (index < 2) {
                    // Near start
                    start = 0;
                } else if (index >= totalDots - 3) {
                    // Near end
                    // e.g. total 10. Max visible 5.
                    // If index is 7, 8, 9 -> show 5,6,7,8,9
                    start = totalDots - maxVisible;
                } else {
                    // In middle
                    start = index - 2;
                }
                
                end = start + maxVisible;
            }

            dots.forEach((dot, i) => {
                // Active State
                if (i === index) {
                    dot.classList.add('active');
                } else {
                    dot.classList.remove('active');
                }

                // Visibility (Pagination)
                if (i >= start && i < end) {
                    dot.style.display = 'block';
                } else {
                    dot.style.display = 'none';
                }
            });
        }
    }
}
